/**
 * A link into a section of a page (/account#job-preferences, /employer/company-profile/edit#locations)
 * scrolls to that section once the page has drawn it and outlines it for a moment (2026-10-15, A6),
 * so people land on the right spot and can see where to fill in. Mounted once in App.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { highlightSection } from './UnsavedChanges';

export default function HashSectionHighlighter() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const id = decodeURIComponent(hash.replace(/^#/, ''));
    if (!id) return;
    let tries = 0;
    const t = window.setInterval(() => {
      tries += 1;
      const el = document.getElementById(id);
      if (el) {
        window.clearInterval(t);
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        highlightSection(el);
      } else if (tries > 25) window.clearInterval(t);
    }, 200);
    return () => window.clearInterval(t);
  }, [pathname, hash]);
  return null;
}
